import React from "react";
import { Box, Text, SimpleGrid, useColorModeValue } from "@chakra-ui/react";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";
import theme from "../../theme";
import "./chartStyles.css";

const ProgressBar = ({ data, title, caption, unit='%' }) => {
  const dataWithPercentage = data.map((item) => ({
    ...item,
    percent: unit==='%'? ((item.value / data.reduce((acc, curr) => acc + curr.value, 0)) * 100).toFixed(2) : item.value,
  }));
  const bgColor = useColorModeValue('chart-box', 'chart-box-dark');
  const chartColors = Object.values(theme.colors.chartColors);
  const dividerColor = useColorModeValue(theme.colors.dividerColor.light, theme.colors.dividerColor.dark);

  return (
    <Box className={`${bgColor} chart-hover-effect`}>
      <Text mb={3} fontSize="xl" fontWeight="600">
        {title}
      </Text>
      <Text>
        {caption}
      </Text>
      <Box className="divider"></Box>
      <Box className="chart-pie-legend" display="flex" flexDirection={{ base: 'column', md: 'row' }} alignItems="center" mt={4}>
        <ResponsiveContainer width="60%" height={300} minWidth="200px">
          <PieChart>
            <Pie
              data={data}
              startAngle={180}
              endAngle={0}
              cx="50%"
              cy="50%"
              innerRadius={60}
              outerRadius={100}
              dataKey="value"
              label={false}
              stroke="none"
            >
              {data.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={chartColors[index % chartColors.length]}
                />
              ))}
            </Pie>
            <Tooltip />
          </PieChart>
        </ResponsiveContainer>
        <Box className="chart-pie-legend">
          <SimpleGrid columns={2} spacing={3} minWidth="250px" width="100%">
            {dataWithPercentage.map((entry, index) => (
              <React.Fragment key={index}>
                <Box display="flex" alignItems="center" minWidth="120px">
                  <Box
                    className="legend-bullet"
                    backgroundColor={chartColors[index % chartColors.length]}
                    mr={2}
                  />
                  <Text className="legend-text" noOfLines={1}>
                    {entry.name}
                  </Text>
                </Box>
                <Text fontSize="md" color={useColorModeValue("#615E83", "#D1D1D1")}>
                    {unit!=='%'? unit : ''}{entry.percent}{unit==='%'? unit : ''}
                </Text>
              </React.Fragment>
            ))}
          </SimpleGrid>
        </Box>
      </Box>
    </Box>
  );
};

export default ProgressBar;
